import { displayError } from '../AppToaster';
export class BufferLoader {
    constructor(context, source, callback) {
        this.loadBuffer = (url, index, languageData) => {
            // Load buffer asynchronously
            const request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.responseType = 'arraybuffer';
            const loader = this;
            request.onload = () => {
                // Asynchronously decode the audio file data in request.response
                loader.context
                    .decodeAudioData(request.response)
                    .then((buffer) => {
                    if (!buffer) {
                        alert('error decoding file data: ' + url);
                        return;
                    }
                    loader.bufferList[index] = {
                        id: this.source[index].id,
                        buffer,
                    };
                    if (++loader.loadCount === loader.sourceList.length) {
                        loader.onload(loader.bufferList);
                    }
                })
                    .catch((error) => {
                    displayError({
                        message: languageData.decodeError,
                        timeout: 3000,
                    });
                });
            };
            request.onerror = () => {
                displayError({
                    message: languageData.loadError,
                    timeout: 3000,
                });
            };
            request.send();
        };
        this.load = languageData => {
            for (let i = 0; i < this.sourceList.length; ++i) {
                this.loadBuffer(this.source[i].uri, i, languageData);
            }
        };
        this.context = context;
        this.source = source;
        this.sourceList = Object.keys(source);
        this.onload = callback;
        this.bufferList = {};
        this.loadCount = 0;
    }
}
//# sourceMappingURL=BufferLoader.js.map